import { IJiraConfig } from '~/domain/IJiraConfig';
import { IJiraIssue } from '~/domain/IJiraIssue';
import { IRequest } from '~/domain/IRequest';

import { mapFieldSelection, mapFieldValue } from './issueField';

/**
 * Translate a jira issue into an IRequest object
 * @param jiraIssue
 * @param config
 */
export const mapJiraRequest = (jiraIssue: IJiraIssue, config: IJiraConfig): IRequest => {
  const {
    fields: {
      addressableRegion,
      addressableVersion,
      buildVersion,
      productionRound,
      reviewDueDate,
      reviewRegion,
      reviewSubmarket,
      vehicleModel,
      vehicleYear,
    },
  } = config;
  const {
    key: requestId,
    fields,
    renderedFields,
  } = jiraIssue;
  const { updated } = renderedFields;
  const {
    summary: title,
    status,
  } = fields;
  return {
    requestId,
    updated,
    status,
    title,
    addressableRegion: mapFieldSelection(fields, addressableRegion),
    addressableVersion: mapFieldValue(fields, addressableVersion),
    buildVersion: mapFieldValue(fields, buildVersion),
    dueDate: renderedFields[reviewDueDate?.key || ''],
    productionRound: mapFieldSelection(fields, productionRound),
    reviewRegion: mapFieldSelection(fields, reviewRegion),
    reviewSubmarket: mapFieldSelection(fields, reviewSubmarket),
    vehicleModel: mapFieldSelection(fields, vehicleModel),
    vehicleYear: mapFieldSelection(fields, vehicleYear),
  };
}
